<template>
  <div class="outerbox">
    <div class="innercoreversion">
      <img width="460px" style="margin-bottom: 36px" src="../image/yidashititle.png" alt="" />
      <!-- <img width="1104px" src="../image/pingpa.png" alt="" /> -->
      <div class="titleboxproject">
        <div class="onerow">
          <div class="rowbox boxserrow ropbox">
            <img src="../image/project/1.png" alt="" />
            <img src="../image/project/2.png" alt="" />
            <img src="../image/project/3.png" alt="" />
            <img src="../image/project/4.png" alt="" />
            <img src="../image/project/12.png" alt="" />
            <!-- <img src="../image/project/5.png" alt="" /> -->
          </div>
        </div>
        <div class="onerow">
          <div class="rowbox">
            <img src="../image/project/6.png" alt="" />
            <img src="../image/project/7.png" alt="" />
            <img src="../image/project/8.png" alt="" />
            <img src="../image/project/9.png" alt="" />
            <img src="../image/project/10.png" alt="" />
            <img src="../image/project/11.png" alt="" />
          </div>
        </div>
        <div class="onerow">
          <div class="rowbox boxserrow bvoubox">
            <!-- <img src="../image/project/12.png" alt="" /> -->
            <!-- <img src="../image/project/13.png" alt="" />
            <img src="../image/project/14.png" alt="" />
            <img src="../image/project/15.png" alt="" /> -->
            <!-- <img src="../image/project/16.png" alt="" /> -->
          </div>
        </div>
        <!-- <div class="onerow">
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
        </div>
        <div class="tworow">
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
        </div>
        <div class="onerow">
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
          <div class="hexagon">
            <div class="content">六边形</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imgPage',
}
</script>


<style lang="less" scoped>
.outerbox {
  background: #f3f9fd;
  height: 783px;
  .innercoreversion {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
.titleboxproject {
  width: 1104px;
  .onerow {
    // padding: 0 100px;
    width: 100%;
    // display: grid;
    // grid-template-columns: repeat(5, 1fr); /* 三列，每列宽度相等 */
    // gap: 20px;
    // justify-items: center;
    .rowbox {
      display: flex;
      img {
        &:hover {
          transform: scale(1.1);
          transform: all 0.3s ease-in-out; //使动画在开始和结束时慢速过渡
          -webkit-transform: scale(1.1);
          -webkit-transition: all 0.3s ease-in-out; //使动画在开始和结束时慢速过渡
        }
      }
    }
    .boxserrow {
      position: relative;
      margin-left: 91px;
    }
    .ropbox {
      bottom: -27px;
    }
    .bvoubox {
      bottom: 27px;
    }
  }
  .tworow {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(6, 1fr); /* 三列，每列宽度相等 */
    gap: 20px;
    justify-items: center;
  }
}
// 六边形盒子
.hexagon {
  position: relative;
  // width: 150px;
  // height: 60px; /* 根据宽度计算出相应的高度 */
  width: 137px;
  height: 91px; /* 根据宽度计算出相应的高度 */
  background-color: #fff; /* 背景颜色 */
  margin: 23px 0; /* 上下边距 */
  box-sizing: border-box;
  .content {
    text-align: center;
    line-height: 91px;
  }
  &:hover {
    transform: scale(1.1);
    transform: all 0.3s ease-in-out; //使动画在开始和结束时慢速过渡
    -webkit-transform: scale(1.1);
    -webkit-transition: all 0.3s ease-in-out; //使动画在开始和结束时慢速过渡
  }
}

.hexagon::before,
.hexagon::after {
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-left: 68px solid transparent;
  border-right: 68px solid transparent;
}

.hexagon::before {
  top: -45px;
  border-bottom: 45px solid #fff; /* 六边形上半部分 */
}

.hexagon::after {
  bottom: -45px;
  border-top: 45px solid #fff; /* 六边形下半部分 */
}
</style>